import { useState } from 'react'

import { AccountPreferenceKeys, OnboardingStatus } from '@ankor-io/common/types/account'

import { useUserContext } from '@/providers/user/useUserContext'
import ConnectedAccountSetup from '@/views/components/Onboarding/ConnectedAccountSetup'
import OrganizationSetup from '@/views/components/Onboarding/OrganizationSetup'

export const RightSideSetup = () => {
  const { preferences, updatePreferences } = useUserContext()
  const [organizationName, setOrganizationName] = useState('')
  const [isBackButtonPressed, setIsBackButtonPressed] = useState(false)

  const handleOrganizationSave = (name: string) => {
    setOrganizationName(name)

    updatePreferences({
      [AccountPreferenceKeys.ONBOARDING_STATUS]: OnboardingStatus.IN_PROGRESS,
    })
  }

  return (
    <div className="w-full lg:max-w-lg flex items-center justify-center p-4 sm:p-6 md:p-8 lg:p-16 order-1 lg:order-2 min-h-[60vh] lg:min-h-screen bg-white dark:bg-gray-900">
      {!preferences?.[AccountPreferenceKeys.ONBOARDING_STATUS] ||
      preferences?.[AccountPreferenceKeys.ONBOARDING_STATUS] === OnboardingStatus.NOT_STARTED ||
      isBackButtonPressed ? (
        <OrganizationSetup
          onSave={handleOrganizationSave}
          organizationName={organizationName}
        />
      ) : (
        <ConnectedAccountSetup goBack={() => setIsBackButtonPressed(true)} />
      )}
    </div>
  )
}

export default RightSideSetup
